import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'loyalty-id-qr-code-scan:action-sheet:title',
    defaultMessage: 'SCAN BEFORE PAYING',
    description: 'Loyalty ID QR code scan action sheet title',
  },
  description: {
    id: 'loyalty-id-qr-code-scan:action-sheet:description',
    defaultMessage: 'To earn points.',
    description: 'Loyalty ID QR code scan action sheet description',
  },
  reminderTitle: {
    id: 'loyalty-id-qr-code-scan:action-sheet:reminder-title',
    defaultMessage: 'Remember:',
    description: 'Loyalty ID QR code scan action sheet reminder',
  },
  reminderDescription: {
    id: 'loyalty-id-qr-code-scan:action-sheet:reminder-description',
    defaultMessage: 'Your phone number is your loyalty ID',
    description: 'Loyalty ID QR code scan action sheet reminder',
  },
  openButtonLabel: {
    id: 'loyalty-id-qr-code-scan:action-sheet:open-button-label',
    defaultMessage: 'Scan Me',
    description: 'Loyalty ID QR code scan action sheet open button label',
  },
});
